import Typography from "antd/lib/typography";
import clsx from "clsx";
import first from "lodash/first";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IUserResource, UserRole, getUserDisplayName } from "@sol/sdk";
import { getTagVariant } from "@sol/sdk/utils/getTagVariant";
import { Avatar } from "@sol/uikit/data-display/Avatar/Avatar";
import { Tag } from "@sol/uikit/data-display/Tag/Tag";

import { getRoleTranslationKey } from "../../../utils/getRole";

type Props = {
    className?: string;
    user: IUserResource & { roles?: UserRole[] };
};

export const UserWithRole: FC<Props> = ({ className, user }) => {
    const [t] = useTranslation();

    const displayName = getUserDisplayName(user);

    const role = first(user.roles);

    const { name, surname, avatarUrl } = user;

    return (
        <div className={clsx("mb-1 flex max-w-[144px] items-center gap-2", className)}>
            <Avatar src={avatarUrl} alt={displayName} className={clsx("shrink-0", { "bg-primary": !avatarUrl })}>
                {`${name?.charAt(0)}${surname?.charAt(0)}`}
            </Avatar>
            <div className="flex w-full flex-1 flex-col items-start gap-1 overflow-hidden">
                <Typography.Text title={displayName} className="line-clamp-2 text-xs text-ellipsis" ellipsis>
                    {displayName}
                </Typography.Text>
                {role && <Tag color={getTagVariant(role)}>{t(getRoleTranslationKey(role))}</Tag>}
            </div>
        </div>
    );
};
